var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg3 = function Svg3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 85,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#3_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.266 52.719h19.078c0 4.343 1.593 6.515 4.781 6.515 1.594 0 2.89-.609 3.89-1.828 1-1.25 1.5-2.875 1.5-4.875 0-5.093-2.656-7.64-7.968-7.64-.375 0-.844.03-1.406.093-.563.032-1.203.078-1.922.141V29.703c.531.031.984.063 1.36.094h.983c5.344 0 8.016-2.453 8.016-7.36 0-4-1.39-6-4.172-6-2.187 0-3.437 1.61-3.75 4.829l-.093.984H1.672c.531-6.75 2.89-12.078 7.078-15.984C12.906 2.296 18.36.312 25.11.312c6.437 0 11.78 2.032 16.03 6.094 4.344 4.032 6.516 9.016 6.516 14.953 0 6.657-2.922 11.735-8.765 15.235 6.468 3.718 9.703 9.312 9.703 16.781 0 6.469-2.297 11.734-6.89 15.797-4.532 4.062-10.423 6.094-17.673 6.094-7.093 0-12.812-1.985-17.156-5.954-4.406-3.968-6.61-9.14-6.61-15.515v-1.078Z",
    fill: "#121213"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#3_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.016 57.406c-1 1.219-2.297 1.828-3.891 1.828-3.188 0-4.781-2.172-4.781-6.515H.266v1.078c0 .31.005.617.015.922.204 5.953 2.402 10.818 6.594 14.593 4.344 3.97 10.063 5.954 17.156 5.954 7.25 0 13.14-2.032 17.672-6.094 4.594-4.063 6.89-9.328 6.89-15.797 0-6.711-2.61-11.908-7.834-15.592a23.953 23.953 0 0 0-1.868-1.19c.65-.389 1.264-.798 1.842-1.226 4.616-3.423 6.923-8.092 6.923-14.008 0-5.937-2.172-10.922-6.515-14.953C36.89 2.344 31.547.313 25.109.313c-6.75 0-12.203 1.984-16.359 5.953-3.765 3.512-6.052 8.173-6.861 13.984-.091.652-.164 1.319-.217 2h18.89l.094-.984c.313-3.22 1.563-4.828 3.75-4.828 2.782 0 4.172 2 4.172 6 0 4.906-2.672 7.359-8.015 7.359h-.985a57.127 57.127 0 0 0-1.36-.094v15.422c.72-.063 1.36-.11 1.923-.14l.078-.01c.528-.056.97-.084 1.328-.084 5.312 0 7.969 2.547 7.969 7.64 0 2-.5 3.625-1.5 4.875Zm-7.797-14.44c.486-.048.932-.075 1.328-.075 2.944 0 5.523.704 7.36 2.466 1.854 1.777 2.609 4.297 2.609 7.174 0 2.339-.59 4.439-1.939 6.125l-.007.01-.008.009c-1.385 1.688-3.252 2.56-5.437 2.56-2.098 0-3.953-.749-5.198-2.446-.822-1.12-1.274-2.515-1.467-4.07H2.282c.201 5.42 2.19 9.738 5.932 13.107l.005.005.005.005c3.902 3.566 9.104 5.43 15.807 5.43 6.857 0 12.24-1.91 16.337-5.583l.01-.01c4.139-3.66 6.216-8.367 6.216-14.298 0-6.754-2.853-11.686-8.7-15.047l-2.955-1.699 2.924-1.751c5.258-3.15 7.793-7.585 7.793-13.519 0-5.382-1.94-9.835-5.876-13.487l-.01-.01-.011-.01c-3.841-3.672-8.674-5.54-14.65-5.54-6.331 0-11.258 1.848-14.978 5.4l-.008.008-.009.008C6.795 10.824 4.697 14.952 3.91 20.25h14.859c.224-1.463.674-2.793 1.48-3.832 1.035-1.333 2.5-1.98 4.158-1.98 1.938 0 3.645.737 4.771 2.358 1.035 1.488 1.401 3.471 1.401 5.642 0 2.807-.772 5.267-2.651 6.992-1.847 1.696-4.425 2.367-7.364 2.367h-.344v11.168Z",
    fill: "#D0DF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "3_svg__a",
    x: 0.266,
    y: 0.313,
    width: 62.328,
    height: 83.953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "3_svg__b",
    x: 0.266,
    y: 0.313,
    width: 62.328,
    height: 83.953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
};
export default Svg3;